import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AircraftList } from '@/components/AircraftList';

export const Route = createFileRoute('/_auth/aircraft/')({
  component: AircraftRoute,
});

function AircraftRoute() {
  const navigate = useNavigate();

  return <AircraftList onBack={() => navigate({ to: '/more' })} />;
}
